module.exports = __webpack_public_path__ + "static/media/ab-shape-3.6854b6f9.png";